import { Button, Flex, useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { ContractTaskDto, UpdateTaskRequest } from "../../../../../../autogen/bff-api";
import { useApiError } from "../../../../../../common/errors/useApiError";
import { useSaveNow } from "../../../../../../common/editing/save-coordinator";
import { contractTaskEditorId } from "../useContractTaskEditor";
import { DateSelector } from "../../../../../../common/input/DateTimeSelectors/DateSelector";

interface Props {
  task: ContractTaskDto;
  onEditComleted: () => void;
  onCancel: () => void;
}

export const EditDueDate = ({ task, onEditComleted, onCancel }: Props) => {
  const [date, setDate] = useState<string | undefined>(task.dueDate);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const displayer = useApiError();
  const { saveNow } = useSaveNow<ContractTaskDto, UpdateTaskRequest>(contractTaskEditorId(task.id));
  return (
    <Flex flexDirection={"column"} w="100%" mt="10px">
      <DateSelector id="contract-task-due-date-picker" defaultDate={date} onChange={async (e) => setDate(e)} />
      <Flex mt="10px">
        <Button
          id="save-due-date-button"
          variant={"solid"}
          colorScheme="teal"
          size="xs"
          isLoading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            try {
              await saveNow({
                dueDate: date,
              });
              setIsLoading(false);
              onEditComleted();
            } catch (e) {
              setIsLoading(false);
              toast({
                title: t("Could not edit due date"),
                description: displayer.message(e),
                status: "error",
              });
            }
          }}
        >
          {t("Save")}
        </Button>
        <Button variant={"solid"} colorScheme="gray" size="xs" ml="5px" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </Flex>
    </Flex>
  );
};
